import React, { useEffect } from 'react';
import Project from '../../components/project/Project'
import Nav from '../../components/nav/Nav';
import BotDiv from '../../components/botdiv/BotDiv';
import Loader from '../../components/preloader/Loader';
import { useParams } from 'react-router-dom';

function ProjectView({ loaderFinished, setLoaderFinished }) {
  const { projectTitle } = useParams();
  
  useEffect(()=>{
    setLoaderFinished(false);
  },[projectTitle, setLoaderFinished]);

  return (
    <div>
        <Loader key={projectTitle} loaderFinished={setLoaderFinished} data={projectTitle} show2={false} />
        {loaderFinished && (
          <>
            <Nav inHome={false}/>
            <Project projectLoader={setLoaderFinished} />
            <BotDiv/>
          </>
        )}
    </div>
  )
}

export default ProjectView